export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/imageWorker.worker.f65250d1.worker.js");
}
